import React from 'react';
import { m as motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { ValueBreakdown } from './ui/ValueBreakdown';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const baseIncludes = ['5 tomos especializados (250+ páginas)', 'Fichas de Pista (25 fichas)', 'Radar del Alumno', 'Semáforo de Correcciones Rápidas', 'Planificador 30 Días', 'Vuelta a Pista'];
const baseExcludes = ['Mapa de Pista (50 fichas) — solo en Kit', 'Programador 12 Meses — solo en Kit'];
const kitIncludes = ['5 tomos especializados (250+ páginas)', 'Fichas de Pista + Radar del Alumno', 'Semáforo de Correcciones Rápidas', 'Planificador 30 Días + Vuelta a Pista', 'Mapa de Pista — 50 fichas de ejercicio', 'Programador 12 Meses — temporada completa'];
export function PricingCards() {
  return <section id="oferta" className="bg-mp-black py-20 md:py-28 scroll-mt-20" data-id="element-202" data-mp="3ojwcj124y9hm">
      <Container data-id="element-203" data-mp="3jj8kcc267mlt">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-204" data-mp="3jkt5xc6ibv7j">
          <SectionTag tone="lime" data-id="element-205" data-mp="3fi6jjqslv2hq">Oferta de lanzamiento</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-206" data-mp="g1qdo7y4wlmz">
            ¿Cuánto vale para ti recuperar tu tiempo?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto mt-10 max-w-[700px] rounded-2xl border border-mp-border bg-mp-dark p-6 md:p-7" data-id="element-207" data-mp="6byjhety5uj1">
          <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-208" data-mp="u0zi6acz9rb4">
            ¿Cuál es la diferencia real entre las dos opciones?
          </p>
          <p className="mt-3 text-sm leading-relaxed text-mp-gray md:text-[15px]" data-id="element-209" data-mp="2t8g94fbdmfwb">
            La versión base te da los 5 tomos y las 5 herramientas para que nunca más improvises una clase. Es
            excelente para tener el sistema completo.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-mp-gray md:text-[15px]" data-id="element-210" data-mp="2jh3exh23vdn4">
            El Kit de Ejecución añade el Mapa de Pista (50 fichas de ejercicios para consultar en 10 segundos) y el
            Programador 12 Meses (tu calendario de temporada de septiembre a junio). Por solo 5€ más, tienes la
            temporada entera resuelta al 100%.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-211" data-mp="20kapjvw26wy2">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-7 md:p-8" data-id="element-212" data-mp="3q0a4jtmczglm">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-213" data-mp="1e9k7tl0ujdcr">Maestro en Pista</p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-214" data-mp="1t2ckq4otoa16">Para aprender y aplicar el sistema</p>

            <ul className="mt-6 space-y-2.5" data-id="element-215" data-mp="1o7q8jzax2dg1">
              {baseIncludes.map(item => <CheckItem key={item} data-id="element-216" data-mp="223ap4o36ajka">{item}</CheckItem>)}
              {baseExcludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-217" data-mp="2bzdojm6n443j">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-mp-gray/50" strokeWidth={2.5} data-id="element-218" data-mp="2bym4n8menut3" />
                  <span className="text-sm text-mp-gray/60 md:text-[15px]" data-id="element-219" data-mp="2713r14xg0rer">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-220" data-mp="cmjfpiv0i881" />

            <ValueBreakdown lines={[{
            label: 'Colección 5 Tomos',
            value: '35,50€'
          }, {
            label: 'Los 5 Bonos Estratégicos',
            value: '25,50€'
          }]} totalLabel="Valor total" totalValue="61,00€" finalPrice="16,90 €" discountPercent="72%" priceTone="white" data-id="element-221" data-mp="cnufl7lc6vtv" />

            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="w-full" showArrow data-id="element-222" data-mp="szedmn4no1r7">
              Empezar con Maestro en Pista
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-223" data-mp="bink19ld83e" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="relative flex flex-col rounded-2xl border-2 border-mp-lime bg-mp-card p-7 shadow-glow-lime md:p-8" data-id="element-224" data-mp="9pcm9ry41pl">
            <span className="absolute -top-3 left-7 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-225" data-mp="3dp3u14l0bvm0">
              Lo elige el 80% de monitores
            </span>

            <p className="mt-2 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-226" data-mp="1qse4i3skk9qs">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-227" data-mp="1gv9fzxb9426t">Incluye todo lo anterior, más:</p>

            <ul className="mt-6 space-y-2.5" data-id="element-228" data-mp="1bxzrqkzllwkk">
              {kitIncludes.map(item => <CheckItem key={item} data-id="element-229" data-mp="175zk06dadzdf">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-230" data-mp="1344ndf6awa5z" />

            <ValueBreakdown lines={[{
            label: 'Todo lo anterior',
            value: '61,00€'
          }, {
            label: 'Kit de Ejecución',
            value: '25,90€'
          }]} totalLabel="Valor total" totalValue="86,90€" finalPrice="21,90 €" discountPercent="75%" priceTone="lime" data-id="element-231" data-mp="134w79sqjcjgf" />
            <p className="-mt-4 mb-4 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-232" data-mp="eizz3h0huzt9">
              Solo 5 € más que la versión base
            </p>

            <CTAButton href={KIT_CHECKOUT_URL} className="w-full" showArrow data-id="element-233" data-mp="5jl6oc0rof64">
              Quiero el sistema completo
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-234" data-mp="9l6q6g7t3rpa" />
          </motion.div>
        </div>

        <p className="mx-auto mt-10 max-w-[600px] text-center text-sm text-mp-gray" data-id="element-235" data-mp="xbam01er6n5q">
          ⏳ Precio de lanzamiento — sube próximamente. Asegura el tuyo hoy.
        </p>
      </Container>
    </section>;
}